import { withStyles } from '@material-ui/core';
import styles from './styles';
import StaffHours from './StaffHours';

export default withStyles(styles)(StaffHours);
